module.exports = __webpack_public_path__ + "assets/images/superbet_21.05d8df8afae5de9165b0c409e4e0fc46.png";